import Typography from '@mui/material/Typography';
import type { JSX } from 'react';
import type { ColumnKey } from '../../constants.ts';
import { displayCellText } from '../../utils/displayCellText.ts';
import { StyledRowTextContainer } from '../styled/StyledComponents.tsx';

type TextCellContainerProps = {
  type: ColumnKey;
  displayValue?: string | null;
};

export const TextCellContainer = ({ type, displayValue }: TextCellContainerProps): JSX.Element | null => {
  const cellText = displayCellText(type, displayValue);

  return (
    <StyledRowTextContainer>
      <Typography variant="body2">{cellText}</Typography>
    </StyledRowTextContainer>
  );
};
